// Dependecies
import React from 'react';

import { useForm } from 'react-hook-form';
import Alert from 'react-bootstrap/Alert';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import Template from '../../components/Template';
import Spinner from '../../components/Spinner';

// images
import alert from '../../../sass/images/alert/alert.svg';
import light from '../../../sass/images/workshop/lightweight-vehicles.svg';
import heavy from '../../../sass/images/workshop/heavy-vehicles.svg';
import edit from '../../../sass/images/workshop/icon-feather-edit.svg';
import close from '../../../sass/images/workshop/close.svg';
import infoAlert from '../../../sass/images/alert/info-alert.svg';
import successAlert from '../../../sass/images/alert/icon-check-alert.svg';
import errorAlert from '../../../sass/images/alert/icon-error-alert.svg';

// hooks
import useGarageWorkShops from '../../hooks/useGarageWorkShops';
import useStatusService from '../../hooks/useStatusService';
import useCity from '../../hooks/useCities';
// Utils
import { contactEmail, contacNumber } from '../../helpers';

function DashboardWorkShops(props) {
  const { t } = props;
  const {
    shopOptions,
    shopDays,
    types,
    brands,
    sistems,
    garageWorkShops,
    itemsistems,
    itembrands,
    itemtypes,
    reload,
    alertUpdate,
    messageError,
    messageAlert,
    loading,
    classEditVenues,
    classEditSistem,
    classEditBrand,
    classEditType,
    classEditDays,
    setClassEditVenues,
    setClassEditSistem,
    setClassEditBrand,
    setClassEditType,
    setClassEditDays,
    setGarageWorkShops,
    submit,
    valueNull,
    days,
  } = useGarageWorkShops();

  const { newMaintenances } = useStatusService();
  const { register, handleSubmit, errors } = useForm();
  const { cities } = useCity();

  /* garage Workshop */
  // handle input change
  const handleInputChange = (e, index) => {
    const { id, value } = e.target;
    const list = [...garageWorkShops];
    list[index][id] = value;

    setGarageWorkShops(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (id, address, phone, check, checkEnabled, cityWorkshop, index) => {
    const list = [...garageWorkShops];
    list[index].id = id;
    list[index].address = address;
    list[index].phone = phone;
    list[index].garage_car = check;
    list[index].enabled = checkEnabled;
    list[index].city_id = cityWorkshop;
    setGarageWorkShops(list);

    list.splice(index, 1);
    setGarageWorkShops(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setGarageWorkShops([
      ...garageWorkShops,
      { id: '0', address: '', phone: '', garage_car: false, enabled: true, city_id: '' },
    ]);
  };
  return (
    <Template
      type={3}
      newMaintenances={newMaintenances}
      classNameContainer="dashboardWorks"
      className="container_menu dashboardWorks"
    >
      {!reload ? (
        <Spinner text={t('alert:reload')}> </Spinner>
      ) : (
        <div className="content_dynamic">
          <form onSubmit={handleSubmit(submit)}>
            {/* Workshop information */}
            <div className="perfil">
              <div className="row no-gutters">
                <div className="col-md-12">
                  <h1>{t('title-profile')}</h1>
                  <p>{t('description-profile')}</p>
                </div>
              </div>
              <div className="info-perfil">
                <div className="row no-gutters">
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="name" className="col-form-label">
                      {t('name-workshop')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.name : valueNull}
                    />
                  </div>
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="nit" className="col-form-label">
                      {t('nit-workshop')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="nit"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.nit : valueNull}
                    />
                  </div>
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="rut" className="col-form-label">
                      {t('rut-workshop')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="rut"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.rut : valueNull}
                    />
                  </div>
                </div>
                <div className="row no-gutters">
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="country" className="col-form-label">
                      {t('country')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="country"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.countryName : valueNull}
                    />
                  </div>
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="city" className="col-form-label">
                      {t('city')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="city"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.cityName : valueNull}
                    />
                  </div>
                  <div className="information-head col-md-4 col-sm-12">
                    <label htmlFor="email" className="col-form-label">
                      {t('email')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="email"
                      readOnly
                      defaultValue={shopOptions ? shopOptions.email : valueNull}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Workshop venues */}
            <div className="info-venues">
              <div className="row no-gutters">
                <div className="col-md-10 col-sm-10 col-11 classPrueba">
                  <h2>
                    <strong>{t('title-info-venues')}</strong>
                  </h2>
                </div>
                <div className="col-md-2 col-sm-2 col-1 button_edit">
                  <button
                    type="button"
                    className="edit-icon"
                    onClick={() => setClassEditVenues(!classEditVenues)}
                  >
                    <img src={classEditVenues ? edit : close} alt={t('alt:edit_information')} />
                  </button>
                </div>
              </div>
              {garageWorkShops.map((garageWorkShop, i) => (
                <div className="row no-gutters checks venues" key={`venues-${garageWorkShop.id}`}>
                  <div className="col-12 col-md-4">
                    <input
                      className="form-control hidden_input"
                      id="address"
                      name={`garageWorkShopsInput[${i}].id`}
                      type="text"
                      value={garageWorkShop.id}
                      onChange={(e) => handleInputChange(e, i)}
                      ref={register({
                        required: true,
                      })}
                      disabled={false}
                    />
                    <label
                      htmlFor="address"
                      className={`col-form-label ${garageWorkShop.garage_car ? 'cars_work' : ''}`}
                    >
                      {t('address')}
                      {i === 0 ? ` ${t('address-main')} ` : ''}
                    </label>
                    <input
                      className={`form-control ${!classEditVenues ? 'disabled-input' : ''}`}
                      id="address"
                      name={`garageWorkShopsInput[${i}].address`}
                      type="text"
                      defaultValue={garageWorkShop.address}
                      value={garageWorkShop.address}
                      onChange={(e) => handleInputChange(e, i)}
                      ref={register({
                        required: true,
                      })}
                      readOnly={garageWorkShop.garage_car}
                      disabled={!!classEditVenues}
                    />
                    {errors.address && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-md-2">
                    <label htmlFor="phone" className="col-form-label">
                      {t('phone')}
                    </label>
                    <input
                      className={`form-control ${!classEditVenues ? 'disabled-input' : ''}`}
                      id="phone"
                      name={`garageWorkShopsInput[${i}].phone`}
                      type="text"
                      value={garageWorkShop.phone}
                      onChange={(e) => handleInputChange(e, i)}
                      ref={register({
                        required: true,
                      })}
                      disabled={!!classEditVenues}
                    />
                    {errors.phone && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-md-2">
                    <label htmlFor="cityWorkshop" className="col-form-label">
                      {t('city')}
                    </label>
                    <select
                      defaultValue={garageWorkShop.city_id == null ? '' : garageWorkShop.city_id}
                      className={`form-control ${!classEditVenues ? 'disabled-input' : ''}`}
                      id="cityWorkshop"
                      name={`garageWorkShopsInput[${i}].cityWorkshop`}
                      ref={register({ required: true })}
                      onChange={(e) => handleInputChange(e, i)}
                      disabled={!!classEditVenues}
                    >
                      <option value="" disabled>
                        {t('select')}
                      </option>
                      {cities.map((cityWorkshop) => (
                        <option value={cityWorkshop.id} key={cityWorkshop.id}>
                          {cityWorkshop.name}
                        </option>
                      ))}
                    </select>
                    {errors.cityWorkshop && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-md-4 button_add_remove box_checkbox profile">
                    {garageWorkShops.length !== 1 && i > 0 && (
                      <>
                        <input
                          id={`garageWorkShopsInput[${i}]`}
                          name={`garageWorkShopsInput[${i}].garage_car`}
                          type="checkbox"
                          value={1}
                          defaultChecked={garageWorkShop.garage_car}
                          ref={register()}
                          onChange={(e) => handleInputChange(e, i)}
                          disabled={!!classEditVenues}
                        />
                        <label
                          htmlFor={`garageWorkShopsInput[${i}]`}
                          className={classEditVenues ? 'disabled-not-allowed' : ''}
                        >
                          {t('garage-car')}
                        </label>
                        &nbsp;&nbsp;
                      </>
                    )}
                    <>
                      <input
                        id={`enabled[${i}]`}
                        name={`garageWorkShopsInput[${i}].enabled`}
                        type="checkbox"
                        value={1}
                        defaultChecked={garageWorkShop.enabled}
                        ref={register()}
                        onChange={(e) => handleInputChange(e, i)}
                        disabled={!!classEditVenues}
                      />
                      <label
                        htmlFor={`enabled[${i}]`}
                        className={classEditVenues ? 'disabled-not-allowed' : ''}
                      >
                        {t('enabled')}
                      </label>
                      &nbsp;&nbsp;
                    </>

                    {!classEditVenues ? (
                      <>
                        {garageWorkShops.length !== 1 && i > 0 && (
                          <button
                            type="button"
                            id="remove-button"
                            onClick={() =>
                              handleRemoveClick(
                                garageWorkShop.id,
                                garageWorkShop.address,
                                garageWorkShop.phone,
                                garageWorkShop.garage_car,
                                garageWorkShop.enabled,
                                garageWorkShop.city_id,
                                i
                              )
                            }
                            disabled={!!classEditVenues}
                          >
                            <strong>-</strong>
                          </button>
                        )}
                        &nbsp;&nbsp;
                        {garageWorkShops.length - 1 === i && (
                          <>
                            <button
                              type="button"
                              id="add-button"
                              onClick={handleAddClick}
                              disabled={!!classEditVenues}
                            >
                              <strong>+</strong>
                            </button>
                          </>
                        )}
                      </>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              ))}
            </div>
            {/* Workshop systems, types and brands */}
            <div className="info-systems">
              <div className="row no-gutters">
                <div className="col-md-10 col-sm-10 col-11">
                  <h2>
                    <strong>{t('title-sistems')}</strong>
                  </h2>
                </div>
                <div className="col-md-2 col-sm-2 col-1 button_edit">
                  <button
                    type="button"
                    className="edit-icon"
                    onClick={() => setClassEditSistem(!classEditSistem)}
                  >
                    <img src={classEditSistem ? edit : close} alt={t('alt:edit_information')} />
                  </button>
                </div>
              </div>
              <div className="row no-gutters checks">
                {itemsistems.map((itemsistem, index) => {
                  const statusSistem = sistems.find((sistem) => itemsistem.id === sistem.id);
                  return (
                    <div className="col-6 col-md-4 col-lg-3" key={`system-${itemsistem.id}`}>
                      <div className="box_checkbox">
                        <input
                          id={`sistem${itemsistem.id}`}
                          name={`sistems[${index}].id`}
                          type="checkbox"
                          value={itemsistem.id}
                          defaultChecked={statusSistem}
                          ref={register()}
                          disabled={!!classEditSistem}
                        />
                        <label
                          htmlFor={`sistem${itemsistem.id}`}
                          className={classEditSistem ? 'disabled-not-allowed' : ''}
                        >
                          {itemsistem.name}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="info-brands">
              <div className="row no-gutters">
                <div className="col-md-10 col-sm-10 col-11">
                  <h2>
                    <strong>{t('title-brands')}</strong>
                  </h2>
                </div>
                <div className="col-md-2 col-sm-2 col-1 button_edit">
                  <button
                    type="button"
                    className="edit-icon"
                    onClick={() => setClassEditBrand(!classEditBrand)}
                  >
                    <img src={classEditBrand ? edit : close} alt={t('alt:edit_information')} />
                  </button>
                </div>
              </div>
              <div className="row no-gutters checks">
                {itembrands.map((itembrand, index) => {
                  const statusBrand = brands.find((brand) => itembrand.id === brand.id);
                  return (
                    <div className="col-6 col-md-4 col-lg-3" key={`brand-${itembrand.id}`}>
                      <div className="box_checkbox">
                        <input
                          id={`brand${itembrand.id}`}
                          name={`brands[${index}].id`}
                          type="checkbox"
                          value={itembrand.id}
                          defaultChecked={statusBrand}
                          ref={register()}
                          disabled={!!classEditBrand}
                        />
                        <label
                          htmlFor={`brand${itembrand.id}`}
                          className={classEditBrand ? 'disabled-not-allowed' : ''}
                        >
                          {itembrand.name}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="info-types">
              <div className="row no-gutters">
                <div className="col-md-10 col-sm-10 col-11">
                  <h2>
                    <strong>{t('title-types')}</strong>
                  </h2>
                </div>
                <div className="col-md-2 col-sm-2 col-1 button_edit">
                  <button
                    type="button"
                    className="edit-icon"
                    onClick={() => setClassEditType(!classEditType)}
                  >
                    <img src={classEditType ? edit : close} alt={t('alt:edit_information')} />
                  </button>
                </div>
              </div>
              <div className="row">
                {itemtypes.map((itemtype, index) => {
                  const statusType = types.find((type) => itemtype.id === type.id);
                  return (
                    <div className="col-12 col-md-6 col-lg-6 segment" key={`types-${itemtype.id}`}>
                      <div className="box_checkbox ">
                        <div className="row no-gutters">
                          <div className="col-8 col-md-6">
                            <input
                              id={`type${itemtype.id}`}
                              name={`types[${index}].id`}
                              type="checkbox"
                              value={itemtype.id}
                              defaultChecked={statusType}
                              ref={register()}
                              disabled={!!classEditType}
                            />
                            <label
                              htmlFor={`type${itemtype.id}`}
                              className={classEditType ? 'disabled-not-allowed' : ''}
                            >
                              {itemtype.name}
                            </label>
                          </div>
                          <div className="col-4 col-md-6">
                            <img
                              src={itemtype.id === 1 ? light : heavy}
                              alt={t('alt:types_vehicle')}
                            />
                          </div>
                        </div>
                        <p>{itemtype.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Workshop hours */}
            <div className="info-calendar">
              <div className="row no-gutters">
                <div className="col-md-10 col-sm-10 col-11">
                  <h2>
                    <strong>{t('days')}</strong>
                  </h2>
                </div>
                <div className="col-md-2 col-sm-2 col-1 button_edit">
                  <button
                    type="button"
                    className="edit-icon"
                    onClick={() => setClassEditDays(!classEditDays)}
                  >
                    <img src={classEditDays ? edit : close} alt={t('alt:edit_information')} />
                  </button>
                </div>
              </div>
              <div className="calendar">
                <div className="row">
                  <div className="col-md-6 days_calendar">
                    <div className="row">
                      {shopDays.map((shopDay, index) => (
                        <div className="col-1 check-days" key={shopDay.id || index}>
                          <input
                            id={`days${index}`}
                            name={`days[${index}].id`}
                            type="checkbox"
                            value={shopDay.id}
                            defaultChecked={shopDay}
                            ref={register()}
                            disabled={!!classEditDays}
                          />
                          <label
                            htmlFor={`days${index}`}
                            className={classEditDays ? 'disabled-not-allowed' : ''}
                          >
                            {days[index]}
                          </label>
                        </div>
                      ))}
                    </div>
                    <br />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 padding-0">
                    <div className="row">
                      <h5>Lunes a Viernes</h5>
                    </div>
                    <div className="row">
                      <div className="col padding-0">
                        <input
                          className={`form-control ${!classEditDays ? 'disabled-input' : ''}`}
                          type="time"
                          id="startTime"
                          name="startTime"
                          ref={register({
                            required: true,
                          })}
                          defaultValue={shopOptions ? shopOptions.initial_service_hours : ''}
                          disabled={!!classEditDays}
                        />
                      </div>
                      <div className="col">
                        <input
                          className={`form-control ${!classEditDays ? 'disabled-input' : ''}`}
                          type="time"
                          id="endTime"
                          name="endTime"
                          ref={register({
                            required: true,
                          })}
                          defaultValue={shopOptions ? shopOptions.final_service_hours : ''}
                          disabled={!!classEditDays}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col padding-0">
                        {errors.startTime && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('alert:required-field')}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="col padding-0">
                        {errors.endTime && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('alert:required-field')}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                  </div>
                  <div className="col-md-6 padding-0">
                    <div className="row">
                      <h5>Sabados y Festivos </h5>
                    </div>
                    <div className="row">
                      <div className="col padding-0">
                        <input
                          className={`form-control ${!classEditDays ? 'disabled-input' : ''}`}
                          type="time"
                          id="startTimeWeekend"
                          name="startTimeWeekend"
                          ref={register({
                            required: true,
                          })}
                          defaultValue={shopOptions ? shopOptions.initial_service_hours_weekend : ''}
                          disabled={!!classEditDays}
                        />
                      </div>
                      <div className="col">
                        <input
                          className={`form-control ${!classEditDays ? 'disabled-input' : ''}`}
                          type="time"
                          id="endTimeWeekend"
                          name="endTimeWeekend"
                          ref={register({
                            required: true,
                          })}
                          defaultValue={shopOptions ? shopOptions.final_service_hours_weekend : ''}
                          disabled={!!classEditDays}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col padding-0">
                        {errors.startTimeWeekend && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('alert:required-field')}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="col padding-0">
                        {errors.endTimeWeekend && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('alert:required-field')}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-md-4" />
                <button
                  type="submit"
                  className="col btn btn-primary send_register"
                  disabled={loading}
                >
                  {loading && <i className="fa fa-refresh fa-spin" />}
                  {loading && <span>&nbsp;&nbsp;&nbsp;&nbsp;{t('send')}</span>}
                  {!loading && <span>&nbsp;&nbsp;&nbsp;&nbsp;{t('update')}</span>}
                </button>
                <div className="col-md-4" /> <br />
              </div>
            </div>
          </form>
          {alertUpdate && (
            <Alert variant="success" className="alert-response">
              <img src={successAlert} alt={t('alt:successAlert')} />
              <p>{t('alert:success')}</p>
            </Alert>
          )}
          {messageError && (
            <Alert variant="danger" className="alert-response">
              <img src={errorAlert} alt={t('alt:errorAlert')} />
              <p>{t('alert:error')}</p>
            </Alert>
          )}
          {messageAlert && (
            <Alert variant="warning">
              <Alert.Heading>
                <img src={infoAlert} alt={t('alt:notification')} />
                <strong>{t('alert:title-info-contact')}</strong>
              </Alert.Heading>
              <p>
                {t('alert:info-contact1')} {contacNumber()} {t('alert:info-contact2')}
                <strong> {contactEmail()} </strong>
              </p>
            </Alert>
          )}
        </div>
      )}
    </Template>
  );
}

DashboardWorkShops.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation(['profileWorkshop', 'alert', 'alt'])(DashboardWorkShops);
